import React from "react";
import PropTypes from "prop-types";
import { styled, Switch, FormControlLabel, Typography } from "@mui/material";
import { PALETTE } from "../../Theme/Palette";

const CustomSwitch = styled(({ checked, ...props }) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple checked={checked} {...props} />
))(({ theme }) => ({
  width: 44,
  height: 20,
  padding: 0,
  "& .MuiButtonBase-root ": {
    position: "relative",
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    background: `linear-gradient(54.23deg, ${PALETTE.dark_pink} 1.96%, ${PALETTE.pink}  99.68%)`,
    transition: "all 300ms ease",
    "&.Mui-checked": {
      color: PALETTE.white,
      "& + .MuiSwitch-track": {
        background: `linear-gradient(54.23deg, ${PALETTE.dark_pink}  1.96%, ${PALETTE.pink}  99.68%)`,
        opacity: 1,
        border: "none",
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 1,
      },
      "& .MuiSwitch-thumb": {
        transform: "translate(-10%,-50%) !important",
        boxShadow: `0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)`,
      },
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: PALETTE.white,
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 1,
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: "2rem",
    background: PALETTE.primary,
    opacity: 1,
  },
  "& .MuiSwitch-thumb": {
    position: "absolute",
    top: "50%",
    left: 0,
    transform: "translate(15%,-50%)",
    boxSizing: "border-box",
    width: 23,
    height: 15,
    borderRadius: "2rem",
    boxShadow: "none",
  },
}));

export function SwitchButton({ label, checked, onChange = () => {}, disabled = false }) {
  return (
    <FormControlLabel
      label={
        <Typography variant="h2" textAlign="right" component="label" marginRight="1rem">
          {label}
        </Typography>
      }
      disabled={disabled}
      onChange={onChange}
      control={<CustomSwitch checked={checked} />}
      labelPlacement="start"
      sx={{ marginRight: 0 }}
    />
  );
}

SwitchButton.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};
